class ParamoOptions {
  constructor(props) {
    const {
      display,
      function_name,
      function_type,
      type,
    } = props;

    this.id = function_name;
    this.field_label = display;
    this.valueType = type;
    this.functionType = function_type;
  }
}

export default ParamoOptions;



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/models/ParamOptions.js